import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVolumeOff"><Path d="M13 3.07104V20.9289L5.74656 17H1V6.99999H5.74656L13 3.07104Z" fill="currentColor"/><Path d="M20.7929 12.1212L22.9142 9.99989L21.5 8.58568L19.3787 10.707L17.2573 8.58568L15.8431 9.99989L17.9644 12.1212L15.8431 14.2425L17.2573 15.6567L19.3787 13.5354L21.5 15.6567L22.9142 14.2425L20.7929 12.1212Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVolumeOff;
